export function clearImageEdgeBlank(params: { image: HTMLCanvasElement; originalImage?: HTMLCanvasElement }): Promise<{
    resImg: HTMLCanvasElement;
    x: number;
    y: number;
    width: number;
    height: number;
}> {
    return new Promise((resolve, reject) => {
        try {
            const { image, originalImage } = params;
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const scale = 1;
            const imageWidth = image.width / scale;
            const imageHeight = image.height / scale;
            canvas.width = imageWidth;
            canvas.height = imageHeight;
            const x = canvas.width / 2;
            const y = canvas.height / 2;

            const canvasImage = document.createElement('canvas');
            const ctxImage = canvasImage.getContext('2d');
            canvasImage.width = imageWidth;
            canvasImage.height = imageHeight;
            ctxImage?.drawImage(image, 0, 0, imageWidth, imageHeight);
            ctx?.translate(x, y);
            ctx?.translate(-x, -y);
            ctx?.drawImage(canvasImage, x - imageWidth / 2, y - imageHeight / 2);
            const imageData = ctx?.getImageData(0, 0, canvas.width, canvas.height);
            const { data = [], width = 0, height = 0 } = imageData || {};
            // 左偏移，从左开始一列一列的查找
            const getOffsetLeft = () => {
                for (let i = 0; i < width; i += 1) {
                    for (let j = 0; j < height; j += 1) {
                        const pxStartIndex = (j * width + i) * 4;
                        if (data[pxStartIndex + 3] > 0) {
                            return Promise.resolve(i);
                        }
                    }
                }
                return Promise.resolve(0);
            };

            // 上偏移，从左开始，一行一行的查找
            const getOffsetTop = () => {
                for (let i = 0; i < height; i += 1) {
                    for (let j = 0; j < width; j += 1) {
                        const pxStartIndex = (i * width + j) * 4;
                        if (data[pxStartIndex + 3] > 0) {
                            return Promise.resolve(i);
                        }
                    }
                }
                return Promise.resolve(0);
            };

            // 右偏移，从右开始，一列一列的查找
            const getOffsetRight = () => {
                for (let i = width - 1; i >= 0; i -= 1) {
                    for (let j = 0; j < height; j += 1) {
                        const pxStartIndex = (j * width + i) * 4;
                        if (data[pxStartIndex + 3] > 0) {
                            return Promise.resolve(i);
                        }
                    }
                }
                return Promise.resolve(0);
            };

            // 下偏移，从右开始，一行一行的查找
            const getOffsetBottom = () => {
                for (let i = height - 1; i >= 0; i -= 1) {
                    for (let j = 0; j < width; j += 1) {
                        const pxStartIndex = (i * width + j) * 4;
                        if (data[pxStartIndex + 3] > 0) {
                            return Promise.resolve(i);
                        }
                    }
                }
                return Promise.resolve(0);
            };

            const queue = [getOffsetLeft(), getOffsetTop(), getOffsetRight(), getOffsetBottom()];
            Promise.all(queue).then((res) => {
                const [startX, startY, endX, endY] = res;
                const contentWidth = (endX - startX) * scale;
                const contentHeight = (endY - startY) * scale;
                if (contentWidth === 0 || contentHeight === 0) {
                    reject(new Error('图片为空'));
                    return;
                }
                const top = startY * scale;
                const left = startX * scale;

                const canvasRes = document.createElement('canvas');
                const ctxRes = canvasRes.getContext('2d');
                canvasRes.width = contentWidth;
                canvasRes.height = contentHeight;
                if (ctxRes) {
                    ctxRes.drawImage(
                        originalImage || image,
                        left,
                        top,
                        contentWidth,
                        contentHeight,
                        0,
                        0,
                        contentWidth,
                        contentHeight,
                    );
                }
                resolve({
                    resImg: canvasRes,
                    x: left,
                    y: top,
                    width: contentWidth,
                    height: contentHeight,
                });
            });
        } catch (e) {
            reject(e);
        }
    });
}
